var React = require('react');

function Transparency (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M37.4583 33.8333H35.5492L34.8725 33.1808C37.2408 30.4258 38.6667 26.8492 38.6667 22.9583C38.6667 14.2825 31.6342 7.25 22.9583 7.25C14.2825 7.25 7.25 14.2825 7.25 22.9583C7.25 31.6342 14.2825 38.6667 22.9583 38.6667C26.8492 38.6667 30.4258 37.2408 33.1808 34.8725L33.8333 35.5492V37.4583L45.9167 49.5175L49.5175 45.9167L37.4583 33.8333ZM22.9583 33.8333C16.9408 33.8333 12.0833 28.9758 12.0833 22.9583C12.0833 16.9408 16.9408 12.0833 22.9583 12.0833C28.9758 12.0833 33.8333 16.9408 33.8333 22.9583C33.8333 28.9758 28.9758 33.8333 22.9583 33.8333Z"}));
}

Transparency.defaultProps = {"width":"58","height":"58","viewBox":"0 0 58 58","fill":"none"};

module.exports = Transparency;

Transparency.default = Transparency;
